module.exports = __webpack_public_path__ + "static/media/billboard_01_A.e74fc6f0.png";